import React, { useState, useEffect } from "react";
import { Container, Row, Col, Ratio } from "react-bootstrap";
import RightFooter from "../common/RightFooter";
import t from "../../Utils/Translation";
import Tooltip from '@mui/material/Tooltip';
import LykioButton from "../common/LykioButton";
import Card from 'react-bootstrap/Card';
import { useNavigate } from "react-router-dom";
import MultiActionAreaCard from "./MultiActionAreaCard";
import {
	AUTHORIZED_URL_PREFIX,
	AxiosConfig
} from '../../Utils/Constants';
import Loading from './../common/Loading';
import axios from 'axios';

const Assessments = () => {
    const [ isLoading, setIsLoading ] = useState(true);
    const [unitUsage, setUnitUsage] = useState([]);
  
    useEffect(() => {
          const fetchUnitUsage = async () => {
              try {
                  const { data } = await axios.post(`${AUTHORIZED_URL_PREFIX}${"/user/getResultsByType"}`,{type: 'Assessment'}, AxiosConfig());
                  setUnitUsage(data.unitUsage);
                  console.log(data.unitUsage);
                  setIsLoading(false);
                  if (!data.success) {
                      console.log('error')
                  }
              } catch (error) {
                  console.log(error);
              }
          };
          fetchUnitUsage();
          
      }, []);
  const navigate = useNavigate();

  return (
    <div className="lykioccs-main-content lykiocss-Valutazione">
        {isLoading ? <Loading/> :
       <>
       <Container className="lykiocss-margin-top-5em">
        <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                <div style={{background: "#006f4b", textAlign:'center', color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'24em'}} className="lykiocss-center">
                    {t('Sharpen your assessment and screening skills')}
                </div>
        </Row>
       </Container>
       <Container className='lykiocss-margin-top-4em'>
        <Row>
            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard completed={false}
                t={t} text={t('Start')} duration={15} level={"advanced"} backgroundColor="#006f4b" lightBackgroundColor="#006f4b" title={t("EVALUATE THREE CANDIDATES BASED ON THEIR PRESENTATIONS AND CV")} 
                cover={unitUsage.filter((item) => item.unitId==='v001').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/VAL1-SELEZIONE+TRA+TRE+CANDIDATI.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/val.png"} 
                link="/assessment" navigate={navigate}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard completed={false}
                t={t} text={t('Start')} duration={8} level={"basic"} backgroundColor="#006f4b" lightBackgroundColor="#006f4b"  title={t("Experience the Blind Screening methodology").toUpperCase()} 
                cover={unitUsage.filter((item) => item.unitId==='v002').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/VAL2-BLINDSCREENING1.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/val_2.jpg"} 
                assessment={true} id={2} openInIframe={true} navigate={navigate} comingSoon={true}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard completed={false}
                t={t} text={t('Start')} duration={5} level={"basic"} backgroundColor="#006f4b" lightBackgroundColor="#006f4b"  title={t("Identify the recruiter's biases").toUpperCase()} 
                cover={unitUsage.filter((item) => item.unitId==='v003').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/VAL3-VIDEOATTORI1.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/val_3.jpg"} 
                assessment={true} id={3} openInIframe={true} navigate={navigate} comingSoon={true}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard completed={false}
                t={t} text={t('Start')} duration={5} level={"basic"} backgroundColor="#006f4b" lightBackgroundColor="#006f4b"  title={t("Assess the recruiter's performance").toUpperCase()} 
                cover={unitUsage.filter((item) => item.unitId==='v004').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/VAL4-VIDEOAVATAR1.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/val_4.jpg"} 
                assessment={true} id={4} openInIframe={true} navigate={navigate} comingSoon={true}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard completed={false}
                t={t} text={t('Start')} duration={5} level={"advanced"} backgroundColor="#006f4b" lightBackgroundColor="#006f4b"  title={t("Deepen the Blind Screening Methodology").toUpperCase()} 
                cover={unitUsage.filter((item) => item.unitId==='v005').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/VAL5-BLINDSCREENING2.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/val_5.jpg"} 
                assessment={true} id={5} openInIframe={true} navigate={navigate} comingSoon={true}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard completed={false}
                t={t} text={t('Start')} duration={3} level={"basic"} backgroundColor="#006f4b" lightBackgroundColor="#006f4b"  title={t("Select the best cv").toUpperCase()} 
                cover={unitUsage.filter((item) => item.unitId==='v006').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/VAL6-IMPATTONOMECANDIDATI.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/val_6.jpg"} 
                assessment={true} id={6} openInIframe={true} navigate={navigate} comingSoon={true}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard completed={false}
                t={t} text={t('Start')} duration={5} level={"basic"} backgroundColor="#006f4b" lightBackgroundColor="#006f4b"  title={t("Analyze the recruiter's language").toUpperCase()} 
                cover={unitUsage.filter((item) => item.unitId==='v007').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/VAL7-LINGUAGGIOMACHO.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/val_7.jpg"} 
                assessment={true} id={7} openInIframe={true} navigate={navigate} comingSoon={true}/>
            </Col>
        </Row>
       </Container>
       </>}
      <RightFooter />
    </div>
  );
};

export default Assessments;